// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Qv4IqOAo33 {
  max-width: 208px;
}
.DlOJH8B30x > div:first-child {
  left: 86px !important;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"notify-root": `Qv4IqOAo33`,
	"notify-root__menuCtn": `DlOJH8B30x`
};
export default ___CSS_LOADER_EXPORT___;
